import { ConnectionProvider } from "../../common/types/integrationConnection";
import paypalLogo from "../../icons/logos/Paypal.svg";

interface Props {
    provider: ConnectionProvider;
}

export const IntegrationConnectionProviderIcon: React.FC<Props> = ({
    provider,
}) => {
    if (provider === ConnectionProvider.PAYPAL) {
        return <img src={paypalLogo} alt="PayPal" />;
    }
};
